// /src/Routes/config.js
import React from "react";
import AdminDashboard from "../Components/Dashboard/AdminDashboard";

const DealDashboard = React.lazy(() =>
  import("../Components/Dashboard/DealDashboard")
);

const Clients = React.lazy(() => import("./lazy/Clients"));
const Stores = React.lazy(() => import("./lazy/Stores"));
const Settings = React.lazy(() => import("./lazy/Settings"));

export const routes = [
  {
    path: "/",
    element: <AdminDashboard />,
    roles: ["admin", "superadmin", "manager"],
    title: "Overview",
  },
  { path: "/clients", element: <Clients />, roles: ["admin", "manager"] },
  { path: "/stores", element: <Stores />, roles: ["admin", "manager"] },
  { path: "/settings", element: <Settings />, roles: ["admin", "superadmin"] },
];
